import React from 'react'
import { navigateTo } from 'gatsby-link'
import styled, { css, injectGlobal } from 'styled-components';
import { VelocityComponent } from 'velocity-react'
import Link from 'gatsby-link'

import { media } from '../../../styles/utils'
import { container, innerContainer, padding, hoverState, bgImage } from '../../../styles/global'
import { ribbon } from '../../../styles/colors'
import { caption } from '../../../styles/type'

import { VideoPlayer } from '../../../components'

class BlockMedia extends React.Component {

	state = {
	
	}

	resolveImageSize = (layout, media) => {
		if (!media) return

		const sizes = {
			'two_up_image_video': media.sizes.medium_large,
			'fullwidth': media.sizes.full_width,
			'horizontal': media.sizes.full_width,
			'vertical': media.sizes.large
		}
		
		return sizes[layout]
	}

	renderMedia = () => {
		const { block_type, media } = this.props;
        const isSingle = block_type == 'single_media' ? true : false;

		const items = media.map((item, i) => {
            
			return (
				<React.Fragment>
					{item.media_type == 'image' && item.layout_type !== 'fullwidth' && (
						<Image
							src={this.resolveImageSize(isSingle ? item.layout_type : block_type, item.image)}
						/>
					)}
					
					{item.media_type == 'image' && item.layout_type == 'fullwidth' && (
						<BGImage
                            image={this.resolveImageSize(isSingle ? item.layout_type : block_type, item.image)}
                            position={item.image_positioning}
						/>
					)}
					
					{item.media_type == 'video' && (
                        <VideoPlayer 
                            key={i}
                            data={item}
                        />
					)}
					
					{item.caption && (
						<Caption
							dangerouslySetInnerHTML={{__html: item.caption}}  
							layout={isSingle? media[0].layout_type : block_type}
						/>
					)}
				</React.Fragment>
			)
		})

		if (items) {
			return items.map((item, i) => {
				return (
					<Wrapper
						key={i}
						type={isSingle? media[0].layout_type : block_type}
					>
						{item}
					</Wrapper>
				)
			})
		}
	}
	
	render() {
		const { block_type } = this.props;

		return (	
			<Container
				type={block_type}
			>
				{this.renderMedia()}
			</Container>
		)
	}
}

const Image = styled.img`
	height: auto;
	width: 100%;
`

const BGImage = styled.div`
	width: 100%;
	height: 100%;
	background-image: url(${props => props.image});
	${bgImage}
    background-position: ${props => props.position};
`

//const Video = styled(VideoPlayer)`
const Video = styled.div`
	width: 100%;
	background: gray;	
`

const Container = styled.div`
	width: 100%;

	${props => {
		if (props.type == 'two_up_image_video') return css`
			${innerContainer};
			display: flex; 
			flex-direction: row;

			${media.phone`
				flex-direction: column;
			`}
		`
	}}
`

const Wrapper = styled.div`

	/* two up media block */
	${props => {
		if (props.type == 'two_up_image_video') return css`
			/* two column layout */
			width: 50%;
			box-sizing: border-box;

			${media.phone`
				width: 100%;
			`}

			&:first-child {
				padding-right: 2.5rem; /* half gutter size */

				${media.phone`
					padding-right: 0;
					margin-bottom: 5rem;
				`}
			}

			&:last-child {
				padding-left: 2.5rem; /* half gutter size */

				${media.phone`
					padding-left: 0;
				`}
			}
		`
	}}


	/* single media - shared */
	${props => {
		if (props.type == 'horizontal' || props.type == 'vertical') return css`
			${innerContainer};
			margin-left: auto;
			margin-right: auto;
		`
	}}


	/* single media - horizontal */
	${props => {
		if (props.type == 'horizontal') return css`
			${media.phone`
				padding: 0;
			`}

			${Image}, ${Video} {
				margin-left: auto;
				margin-right: auto;
			}
		`
	}}


	/* single media - vertical */
	${props => {
		if (props.type == 'vertical') return css`
			display: flex;
			flex-direction: column;
			align-items: center;

			${Image} {
				max-width: 680px;

				${media.laptop`
					max-width: 534px;
				`}

				${media.tablet`
					max-width: 400px;
				`}
			}

			${Video} {
				max-width: 620px;
				max-height: 920px;

				${media.laptop`
					max-width: 533px;
					max-height: 720px;
				`}

				${media.tablet`
					max-width: 400px;
					max-height: 540px;
				`}

				${media.phone`
					max-width: 295px;
					max-height: 420px;
				`}
			}
		`
	}}


	/* single media - fullwidth */
	${props => {
		if (props.type == 'fullwidth') return css`
			width: 100%;

			${BGImage}, ${Video} {
				height: 600px;

				${media.laptop`
					height: 500px;
				`}

				${media.tablet`
					height: 400px;
				`}

				${media.phone`
					height: 235px;
				`}
			}
			
	`}}
`


const Caption = styled.div`
	margin-top: 2rem;

	${media.tablet`
		display: flex;
		justify-content: center;
	`}

	${media.phone`
		max-width: 360px;
	`}

	${props => {
		if (props.layout == 'fullwidth' || props.layout == 'horizontal') return css` 
			${innerContainer};
			margin-left: auto;
			margin-right: auto;
		`
	}}

	${props => {
		if (props.layout == 'vertical') return css`
			display: flex;
			justify-content: center;
			width: 100%;
		`
	}}

	> * {
		${caption};

		${props => {
			if (props.layout !== 'two_up_image_video') return css`
				width: 50%;
				padding-right: 2.5rem; /* half gutter size */
				box-sizing: border-box;

				${media.tablet`
					width: 360px;
					max-width: 100%;
					padding-right: 0;
				`}
			`
		}}
	}
`


BlockMedia.wrapper = css`
	display: flex;
	justify-content: center;
`

export default BlockMedia



// WEBPACK FOOTER //
// ./src/components/Block/templates/BlockMedia.js